import React from 'react';
const ClientValidationContext = React.createContext(false);
export default ClientValidationContext;